export default {

    newCreatedPerformance: {},
}